import React from 'react';

import './styles.less';

export const VideoPlayerPopup = ( props ) => {
    return (
        <div className="video-player-popup">
            { props.children }
        </div>
    );
};

VideoPlayerPopup.Header = ( props ) => {
    return (
        <div className="video-player-popup-header">
            { props.children }
        </div>
    );
};

VideoPlayerPopup.Body = ( props ) => {
    return (
        <div className="video-player-popup-body">
            { props.children }
        </div>
    );
};

VideoPlayerPopup.Footer = ( props ) => {
    return (
        <div className="video-player-popup-footer">
            { props.children }
        </div>
    );
};
